import { AppConfig } from "../../config";
import axios from "axios";
import { trackPromise } from "react-promise-tracker";

let origin = window.location.origin;

// let token =
//   "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ0b2tlbiI6IjM2MWU1ZWYyODE0NThjOTk0MGVmNTY1MWM4ZTZlMGEyIiwidXNlcm5hbWUiOiJkZW1vMiIsIm5hbWUiOiJEZW1vIDIifQ.oED-xWn9guldkGKAjKDP8ipszNBCavEds0vB1CbkTtv2KU9vu38pLDGbFv6PsqwW5SUJL9gehPcn0ox08qcS2yppN_clt8vcUcYP0CvCpWWZVRi2SGN7itrC0xgPiIE0kPd85icDUbzrh16PnC_HPOwYkvsWYYwBB3NIXRKz2E_iSx-AT9RT4Nijug7cAam8fU2NDSRnt1h17GFil1_m78w-BIPATSwk8PKCkN33foXkBM5uy_1fWQakTsZv0h9_Wcu1Brp1eBJz2HQHEzxQBJPyPgjQVgMNAznbP7qzufhHwWpXSF1wK5XZXYTEcG7gEM9wHLMvMUcwV4T_Lk8paw";

// Demo 2 Account
let token =
  // "12";
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ0b2tlbiI6ImVkMTM2NjBhYWYwYzdjNDZhODg3MGQ2ZDI1NmJmYTBmIiwidXNlcm5hbWUiOiJuaXJtYWxkdXJhaSIsIm5hbWUiOiJOaXJtYWwgRHVyYWkgWSJ9.Gubgh18upzRkfW8c8Q0uPc1pvLT0SOjwV1QYkIbtjwntgqtO7e4gOhhg2Hq4r5KxLjsXbZFTQvuA2ysUnnsQaO4Iv5NUE97qz_i6T7lr-WLcdoJNEQQu7bXS9scpEwwn9I6VDpXeSy5FSP3UWERRPzy_0u9c8AeiWo0NxHme7MDW5gH1mI3kayZbiNfXEjn5WsT2oIHjrh2JhXp3Op8PD2upvaYCvb3RhV-CfNBmyZ5Za01JxDzMq9vmcLsXD8UpmM_6Q3cR_Kq6sZOfdSgEjg4C_LFeRjtUWjMr3P0cW_xhQc7wLDoUy3vEYS8m3SpUKX8sM4FBpc8FrOScSGmqCQ";

// Sukanta Account
//  let token =
//  "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ0b2tlbiI6IjA2NDE5YjQwYTlhYzUwOTE4MTYxYzYwMjUxMGYyNTZjIiwidXNlcm5hbWUiOiJzdWthbnQiLCJuYW1lIjoiU3VrYW50YSBEYXNndXB0YSJ9.KAa9pj53aahvo7_dHjIlCZJHpsnTFc2_Z33ZPBAE4HGUtEzKKq8Lw0-sxiJCdWsPwt7CLUYli97pio4mqW8HevM1nYniqdKszl9W_cC57QVDaJZvKBWajPjmy62bGAHt2T289Ke0--xcthT23PM3vltgGNfHzsKeSdFPdeDg3OgSnZRTgbuhL8qbFdyEvhjhzEJEvTP7qixGnMCEmTI0NU6Znemz1cwOP2HlU6-NbC6mZAk1-iVW93qsk-2Lk6WA6idBeUjTNNWXY0F58yVjckjfAvcnyweh1pN85pAPcnVsKSzPgRXtNbmyKDUgrjoAOI8di7lke4QlooSVedMzgg";
//  "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ0b2tlbiI6IjJlMWM1YTJjYWY4OGJhYzNlZDU3MGIyM2RkYjUwNDlkIiwidXNlcm5hbWUiOiJzdWthbnQiLCJuYW1lIjoiU3VrYW50YSBEYXNndXB0YSJ9.gZZFi1nPNtXPfunT1ZVeDUwsA41BYLFKn7ZUFC_cq3L811O0EugYcm791_tjUqa_Q30QBxpfZTUI-OJ2-xExdO3oq-y462xfag26diGD8BB9EEhLuRluQ5R6LT9LDwHBVR7Ir8oGGCVs70_3RZuAU004mv7xGXnyc6UojAzCRRoBeV6dROZTSmGqN6tPSoXh18tuRC33Xk6w0KlOxGbgG-1SZqSUjjfFx8TKJfBoUlOOFyyBKwn1QUYvWh-E0AV4mQTSKvcJAsC6kbd3iPwFqY4tqd6E0Pq8wz2cVOLzOfmq24_Q11bZsGm7KYSe_i0heC5TuxyRgZ9JeBZUWq0ebQ";

if (origin == "http://localhost:19006") {
  origin = "https://serviceprovider.1superapp.com";
  // origin = "https://postproduction.1superapp.com";
}

export async function api(url, pass_data = {}) {
  let request_method = "GET";
  let formData;

  if (pass_data.hasOwnProperty("get")) {
    url = url + append_url(pass_data.get);
  }
  if (pass_data.hasOwnProperty("post")) {
    request_method = "POST";
    formData = append_data(pass_data.post);
  }

  let option = {
    // withCredentials: true,
    method: request_method,
    url: AppConfig.base_url.api + url,
    // headers: { "1id": token },
  };

  if (formData) {
    option.data = formData;
  }

  const dataPromise = await trackPromise(
    // axios(option, { headers: { Authorization: "Bearer " + token } })
    axios(option)
      .then((res) => {
        let res_pass = {
          status: true,
          status_code: res.status,
          status_text: res.statusText,
          response: res.data,
        };
        return res_pass;
      })
      .catch((err) => {
        let res_pass = {
          status: false,
          // status_code: err.response.status,
          // status_text: err.response.statusText,
          response: error_handler(err),
        };
        return res_pass;
      })
  );

  return dataPromise;
}

function append_url(data) {
  let pass_string = "";
  Object.entries(data).forEach(([key, value], index) => {
    if (index == 0) {
      let join_data = "?" + key + "=" + value;
      pass_string = pass_string + join_data;
    } else {
      let join_data = "&" + key + "=" + value;
      pass_string = pass_string + join_data;
    }
  });
  return pass_string;
}

function append_data(data) {
  const postdata = new FormData();
  for (const items in data) {
    if (data[items].isArray || isObject(data[items])) {
      postdata.append(items, JSON.stringify(data[items]));
    } else {
      postdata.append(items, data[items]);
    }
  }
  return postdata;
}

function isObject(data) {
  return data instanceof Object;
}

function error_handler(error) {
  if (error.response == undefined) {
    // console.log("Network Error");
    return "Network Error";
  } else if (error.response.status === 401) {
    console.log("Unauthorized Error", error.response.data.auth_loggedin);

    if (error.response.data.auth_loggedin == false) {
      // return "Unauthorized Error";
      window.location = origin + "/app/login?r=" + window.location.href;
      // window.location = origin + "/app_test/login?r=" + window.location.href;
    }
  }
}
